import React from 'react';
import { Group, Text, Line } from 'react-konva';
import { wallLength, wallMidpoint, wallAngle, formatDimension } from './floorPlanUtils';

function FloorPlanDimension({ wall, unit, zoom }) {
  const length = wallLength(wall);
  if (length < 1) return null;

  const mid = wallMidpoint(wall);
  const angle = wallAngle(wall);
  const label = formatDimension(length, unit);

  // Offset the label perpendicular to the wall
  const offset = 14 / zoom;
  const perpX = -Math.sin(angle) * offset;
  const perpY = Math.cos(angle) * offset;

  const fontSize = Math.max(10, 12 / zoom);

  // Normalize angle for readability (keep text upright)
  let textAngle = (angle * 180) / Math.PI;
  if (textAngle > 90 || textAngle < -90) {
    textAngle += 180;
  }

  return (
    <Group>
      {/* Dimension text */}
      <Text
        x={mid.x + perpX}
        y={mid.y + perpY}
        text={label}
        fontSize={fontSize}
        fill="#666"
        align="center"
        offsetX={label.length * fontSize * 0.3}
        offsetY={fontSize / 2}
        rotation={textAngle}
      />

      {/* Small tick marks at endpoints */}
      <Line
        points={[
          wall.x1 + perpX * 0.5, wall.y1 + perpY * 0.5,
          wall.x1 + perpX * 1.5, wall.y1 + perpY * 1.5,
        ]}
        stroke="#999"
        strokeWidth={0.5 / zoom}
      />
      <Line
        points={[
          wall.x2 + perpX * 0.5, wall.y2 + perpY * 0.5,
          wall.x2 + perpX * 1.5, wall.y2 + perpY * 1.5,
        ]}
        stroke="#999"
        strokeWidth={0.5 / zoom}
      />
    </Group>
  );
}

export default React.memo(FloorPlanDimension);
